<template>
    <div class="main-content people" v-cloak>
        <div class="container">
            <div class="people">
                <div class="events-group" v-if="active_people_tab === 'adults'">
                    <div class="events-group-sorting" v-if="adults && adults.length > 0">
                        <div class="events-group-sorting-left">
                            <span v-if="sorted_by_label" class="icon icon-sort-down"></span>{{ sorted_by_label }}
                        </div>
                        <div class="events-group-sorting-right">
                            <icon-dropdown
                                @selected="do_action"
                                :options="[
                                    {
                                        label: 'Sorted by name asc',
                                        value: 'name_asc'
                                    },
                                    {
                                        label: 'Sorted by name desc',
                                        value: 'name_desc'
                                    }
                                ]"
                                icon_class="icon icon-sort"
                            ></icon-dropdown>
                        </div>
                    </div>
                    <div class="people-list" :style="{ height: `${adults_list_container_height}px` }">
                        <people-group
                            v-if="adults && adults.length > 0"
                            v-for="(adult, inx) in adults"
                            :person="adult"
                            :key="inx"
                        ></people-group>
                        <div v-if="adults && adults.length === 0" class="no-results">No adults to add</div>
                    </div>
                </div>
                <div class="events-group" v-else>
                    <div class="events-group-sorting" v-if="kids && kids.length > 0">
                        <div class="events-group-sorting-left">
                            <span v-if="sorted_by_label" class="icon icon-sort-down"></span>{{ sorted_by_label }}
                        </div>
                        <div class="events-group-sorting-right">
                            <icon-dropdown
                                @selected="do_action"
                                :options="[
                                    {
                                        label: 'Sorted by name asc',
                                        value: 'name_asc'
                                    },
                                    {
                                        label: 'Sorted by name desc',
                                        value: 'name_desc'
                                    }
                                ]"
                                icon_class="icon icon-sort"
                            ></icon-dropdown>
                        </div>
                    </div>
                    <div class="people-list" :style="{ height: `${adults_list_container_height}px` }">
                        <people-group
                            v-if="kids && kids.length > 0"
                            v-for="(kid, inx) in kids"
                            :person="kid"
                            :key="inx"
                        ></people-group>
                        <div v-if="kids && kids.length === 0" class="no-results">No kids to add</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import iconDropdown from "@/components/pages/icon-dropdown.vue";
import peopleGroup from "./people-group.vue";

export default {
    name: "people-page",
    components: { iconDropdown, peopleGroup },
    data() {
        return {
            sorted_by: null,
            sorted_by_label: null,
            drop_shown: false,
            adults_list_container_height: 0
        };
    },
    created() {
        window.addEventListener("resize", this.resized);
    },
    mounted() {
        this.get_people(this.sorted_by);
        this.calculateHeight();
    },
    resized() {
        this.calculateHeight();
    },
    computed: {
        ...mapState("StorePeople", ["people", "active_people_tab"]),
        ...mapGetters("StorePeople", ["adults", "kids"])
    },
    methods: {
        ...mapActions("StorePeople", ["get_people"]),
        calculateHeight() {
            Vue.nextTick(() => {
                this.adults_list_container_height =
                    window.innerHeight - document.getElementById("main-menu").clientHeight - 110;
                if (
                    document.getElementById("mobile-menu") &&
                    document.getElementById("mobile-menu").style.display !== "none"
                ) {
                    this.adults_list_container_height =
                        this.adults_list_container_height -
                        document.getElementsByClassName("footer-mobile")[0].clientHeight;
                }
            });
        },
        do_action(pl) {
            this.sorted_by_label = pl.label;
            this.sorted_by = pl.value;
            this.get_people(this.sorted_by);
        }
    }
};
</script>

<style scoped>
[v-cloak] {
    display: none;
}

.people-list {
    overflow-y: auto;
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none;
    overflow-y: auto;
    position: relative;
}

.people-list::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
}

@media (max-width: 820px) {
    .people-list {
        height: initial !important;
        padding-top: 62px;
    }

    .people.main-content {
        padding-top: 0 !important;
        height: 60vh;
        overflow: auto;
    }

    .events-group-sorting {
        height: 2.4rem !important;
        padding-top: 1.8rem !important;
        position: fixed;
        width: 100%;
        left: 0;
        background: #fafafa;
        z-index: 100;
        margin-top: -1px;
    }

    .events-group-sorting-left {
        margin-left: 0.8rem;
    }
    .events-group-sorting-right {
        margin-right: 0.8rem;
    }
}

.events-group {
    padding-bottom: 0rem;
}

.events-group-sorting {
    padding-bottom: 0.6rem;
}
</style>
